import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Footer-Banner" }
const _hoisted_2 = { class: "App-Footer-Banner-H" }
const _hoisted_3 = { class: "App-Footer-Banner-H-M" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_get_started = _resolveDirective("get-started")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", {
            "f-w-700": "",
            "m-tb-0": ""
          }, [
            _createTextVNode(" Let us help you"),
            _createElementVNode("br"),
            _createTextVNode(" find entrepreneurial talent that will create boost for your startup team. ")
          ], -1)),
          _cache[2] || (_cache[2] = _createElementVNode("p", null, " Share an entrepreneurial opportunity, and get rapid access to talent who will boost your team for the challenge at hand. ", -1)),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            icon: "el-icon-right",
            size: "large",
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Get Started ", -1)
            ]))]),
            _: 1
          })), [
            [_directive_get_started]
          ])
        ])
      ])
    ])
  ]))
}